import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "min-h-screen bg-gray-lightShow" }
const _hoisted_2 = { class: "flex space-x-4 p-4" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "table" }
const _hoisted_5 = { class: "text-xl table-cell align-middle text-black" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "border-b-2 ml-4 border-black" }, null, -1)
const _hoisted_7 = { class: "px-4" }
const _hoisted_8 = { class: "flex space-x-4" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "table" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "text-sm table-cell align-middle" }, "ユーザー情報")
], -1)
const _hoisted_10 = { class: "flex space-x-4" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "table" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "text-sm table-cell align-middle" }, "決済情報")
], -1)
const _hoisted_12 = { class: "flex space-x-4" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "table" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "text-sm table-cell align-middle" }, "住所管理")
], -1)
const _hoisted_14 = {
  key: 0,
  class: "flex border-b border-zinc-200 justify-between py-4"
}
const _hoisted_15 = { class: "flex space-x-4" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "table" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "text-sm table-cell align-middle" }, "パスワード変更")
], -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "border-b-2 ml-4 border-black mt-10" }, null, -1)
const _hoisted_18 = { class: "px-4" }
const _hoisted_19 = { class: "flex space-x-4" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", { class: "table" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "text-sm table-cell align-middle" }, " プライバシーポリシー ")
], -1)
const _hoisted_21 = { class: "flex space-x-4" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("div", { class: "table" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "text-sm table-cell align-middle" }, "利用規約")
], -1)
const _hoisted_23 = { class: "flex space-x-4" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("div", { class: "table" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "text-sm table-cell align-middle" }, "問い合わせ")
], -1)
const _hoisted_25 = {
  key: 1,
  class: "flex border-b border-zinc-200 justify-between py-4"
}
const _hoisted_26 = { class: "flex space-x-4" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("div", { class: "table" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "text-sm table-cell align-middle" }, "ログアウト")
], -1)
const _hoisted_28 = { class: "flex space-x-4" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("div", { class: "table" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "text-sm table-cell align-middle" }, "退会")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_UserIcon = _resolveComponent("UserIcon")!
  const _component_EnvelopeIcon = _resolveComponent("EnvelopeIcon")!
  const _component_ChevronRightIcon = _resolveComponent("ChevronRightIcon")!
  const _component_CreditCardIcon = _resolveComponent("CreditCardIcon")!
  const _component_MapPinIcon = _resolveComponent("MapPinIcon")!
  const _component_ShieldExclamationIcon = _resolveComponent("ShieldExclamationIcon")!
  const _component_DocumentTextIcon = _resolveComponent("DocumentTextIcon")!
  const _component_UserMinusIcon = _resolveComponent("UserMinusIcon")!
  const _component_ArrowRightOnRectangleIcon = _resolveComponent("ArrowRightOnRectangleIcon")!
  const _component_SBottomBar = _resolveComponent("SBottomBar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", null, [
          (_ctx.lineProfile?.pictureUrl)
            ? (_openBlock(), _createElementBlock("img", {
                key: 0,
                class: "rounded-full w-20",
                src: _ctx.lineProfile?.pictureUrl,
                alt: ""
              }, null, 8, _hoisted_3))
            : (_openBlock(), _createBlock(_component_UserIcon, {
                key: 1,
                class: "w-20 rounded-full"
              }))
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.userProfile.nickName), 1)
        ])
      ]),
      _hoisted_6,
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", {
          class: "flex border-b border-zinc-200 justify-between py-4",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.goProfileEditor && _ctx.goProfileEditor(...args)))
        }, [
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_component_EnvelopeIcon, { class: "w-6 h-6" }),
            _hoisted_9
          ]),
          _createVNode(_component_ChevronRightIcon, { class: "w-6 h-6" })
        ]),
        _createElementVNode("div", {
          class: "flex border-b border-zinc-200 justify-between py-4",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.goPaymentList && _ctx.goPaymentList(...args)))
        }, [
          _createElementVNode("div", _hoisted_10, [
            _createVNode(_component_CreditCardIcon, { class: "w-6 h-6" }),
            _hoisted_11
          ]),
          _createVNode(_component_ChevronRightIcon, { class: "w-6 h-6" })
        ]),
        _createElementVNode("div", {
          class: "flex border-b border-zinc-200 justify-between py-4",
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.goAddressList && _ctx.goAddressList(...args)))
        }, [
          _createElementVNode("div", _hoisted_12, [
            _createVNode(_component_MapPinIcon, { class: "w-6 h-6" }),
            _hoisted_13
          ]),
          _createVNode(_component_ChevronRightIcon, { class: "w-6 h-6" })
        ]),
        false
          ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
              _createElementVNode("div", _hoisted_15, [
                _createVNode(_component_EnvelopeIcon, { class: "w-6 h-6" }),
                _hoisted_16
              ]),
              _createVNode(_component_ChevronRightIcon, { class: "w-6 h-6" })
            ]))
          : _createCommentVNode("", true)
      ]),
      _hoisted_17,
      _createElementVNode("div", _hoisted_18, [
        _createElementVNode("div", {
          class: "flex border-b border-zinc-200 justify-between py-4",
          onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.goPrivacy && _ctx.goPrivacy(...args)))
        }, [
          _createElementVNode("div", _hoisted_19, [
            _createVNode(_component_ShieldExclamationIcon, { class: "w-6 h-6" }),
            _hoisted_20
          ]),
          _createVNode(_component_ChevronRightIcon, { class: "w-6 h-6" })
        ]),
        _createElementVNode("div", {
          class: "flex border-b border-zinc-200 justify-between py-4",
          onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.goTerms && _ctx.goTerms(...args)))
        }, [
          _createElementVNode("div", _hoisted_21, [
            _createVNode(_component_DocumentTextIcon, { class: "w-6 h-6" }),
            _hoisted_22
          ]),
          _createVNode(_component_ChevronRightIcon, { class: "w-6 h-6" })
        ]),
        false
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "flex border-b border-zinc-200 justify-between py-4",
              onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.goProfileDelete && _ctx.goProfileDelete(...args)))
            }, [
              _createElementVNode("div", _hoisted_23, [
                _createVNode(_component_UserMinusIcon, { class: "w-6 h-6" }),
                _hoisted_24
              ]),
              _createVNode(_component_ChevronRightIcon, { class: "w-6 h-6" })
            ]))
          : _createCommentVNode("", true),
        false
          ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
              _createElementVNode("div", _hoisted_26, [
                _createVNode(_component_ArrowRightOnRectangleIcon, { class: "w-6 h-6" }),
                _hoisted_27
              ]),
              _createVNode(_component_ChevronRightIcon, { class: "w-6 h-6" })
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", {
          class: "flex border-b border-zinc-200 justify-between py-4",
          onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.goProfileDelete && _ctx.goProfileDelete(...args)))
        }, [
          _createElementVNode("div", _hoisted_28, [
            _createVNode(_component_UserMinusIcon, { class: "w-6 h-6" }),
            _hoisted_29
          ]),
          _createVNode(_component_ChevronRightIcon, { class: "w-6 h-6" })
        ])
      ])
    ]),
    _createVNode(_component_SBottomBar)
  ]))
}